import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ProcessesService } from './services/processes.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { EditProcessComponent } from './edit-process/edit-process.component';
import { FetchProcessesComponent } from './fetch-processes/fetch-processes.component';
import { HttpClientModule } from '@angular/common/http';


@NgModule({
  declarations: [
    AppComponent,
    EditProcessComponent,
    FetchProcessesComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [ProcessesService],
  bootstrap: [AppComponent]
})
export class AppModule { }
